const ja = {
  services: {
    seoTitle: "サービス · Hotel Ciutat Martorell（マルトレイ）",
    seoDesc: "ホテルと客室のすべてのサービス：ビジネスコーナー、レストランMy Bar、駐車場、ジム、無料WiFi、24時間対応フロントなど。",
    eyebrow: "サービス",
    title: "快適なご滞在に必要なすべて",
    hotelTitle: "ホテルのサービス",
    hotel: [
      "エアコンと暖房",
      "エレベーター",
      "毎日の朝食ビュッフェ",
      "ビジネスコーナー",
      "手荷物預かり",
      "ジム",
      "視聴覚設備",
      "駐車場",
      "24時間対応フロント",
      "レストランMy Bar、昼食と夕食を毎日営業",
      "24時間ルームサービス",
      "会議・宴会用の部屋",
      "ランドリー／ドライクリーニングサービス",
      "印刷サービス",
      "無料WiFi",
    ],
    roomsTitle: "客室内",
    rooms: [
      "車いす・身体の不自由な方に対応",
      "個別エアコンと暖房",
      "バスアメニティ",
      "シャワーまたはバスタブ、ビデ付きの完全なバスルーム",
      "デスク",
      "ミニバー",
      "ヘアドライヤー",
      "USB入力付き液晶テレビ",
      "客室とバスルームの電話",
      "無料WiFi",
      "ベビーベッド利用可",
      "エキストラベッド",
      "禁煙客室",
    ],
    fitness: {
      eyebrow: "フィットネス",
      title: "フィットネスルーム",
      text: "ご滞在中もトレーニングを。ランニングマシン、エアロバイク、ダンベルを備えたフィットネスルームをご利用いただけます。",
      alts: ["エアロバイク、ランニングマシン、タオルを備えたフィットネスルーム", "鏡の前にランニングマシン、バイク、ダンベルを備えたフィットネスルーム"],
    },
    shop: {
      eyebrow: "公式グッズ",
      title: "サッカーの情熱を、フロントで",
      text: "フロントでは、FCバルセロナとレアル・マドリードの公式グッズをご用意しています。お気に入りチームの情熱をお持ち帰りください。",
      note: "フロントのみでの販売",
      cta: "フロントでお問い合わせ",
      clubs: [
        { name: "FCバルセロナ", items: "ユニフォーム、キャップ、マフラー、バックパック、ボールなど。" },
        { name: "レアル・マドリード", items: "ユニフォーム、キット、キャップ、ボール、マフラーなど。" },
      ],
    },
  },
  nav: {
    nye: "2026 大晦日",
    hotel: "ホテル",
    rooms: "客室",
    services: "サービス",
    corporate: "法人・会議",
    events: "イベント・ウエディング",
    restaurant: "レストラン",
    location: "アクセス",
    biosphere: "サステナビリティ",
    gallery: "ギャラリー",
    blog: "ブログ",
    contact: "お問い合わせ",
    book: "公式予約",
    menu: "メニュー",
    close: "閉じる",
    call: "電話する",
    map: "地図",
    bookShort: "予約",
  },
  hero: {
    availability: "空室を確認",
    checkin: "チェックイン",
    checkout: "チェックアウト",
    adults: "大人",
    children: "子供",
    promo: "プロモコード",
    promoPlaceholder: "任意",
    bestPrice: "ここからのご予約で最低価格保証",
    scroll: "スクロール",
  },
  attrs: [
    { t: "最低価格保証", d: "公式予約で" },
    { t: "柔軟なキャンセル", d: "料金プランによる" },
    { t: "ビュッフェ朝食", d: "06:30〜10:30" },
    { t: "専用駐車場", d: "追加料金あり、空き状況により異なります" },
    { t: "Renfe・FGCまで100m", d: "バルセロナまで30分" },
  ],
  marquee: ["マルトレイ", "バルセロナまで30分", "モンセラット", "Renfe・FGCまで100m", "SEAT-CUPRAビジネスエリア", "4つ星の快適さ", "92室", "公式予約"],
  home: {
    presEyebrow: "ホテル",
    stats: [
      { n: "92", l: "室のスタンダード客室" },
      { n: "100m", l: "Renfe・FGCから" },
      { n: "30分", l: "バルセロナと空港から" },
      { n: "180", l: "名収容のメインホール" },
    ],
    roomsEyebrow: "客室",
    roomsTitle: "お好みに合わせた安らぎ",
    roomsText: "ビジネス旅行者、ご家族、長期滞在のために設計された2つの客室タイプ。",
    roomsCta: "すべての客室を見る",
    from: "〜より",
    detail: "詳細を見る",
    corpEyebrow: "法人・会議",
    corpTitle: "ビジネスハブ|SEAT-CUPRAから5分",
    corpFeatures: ["会議室3室", "最大180名収容", "WiFi接続とAV機材", "コーヒーブレイクとビジネスランチ"],
    corpCta: "お見積もりを依頼",
    corpSecondary: "会議室を見る",
    restEyebrow: "ガストロノミー",
    restCta: "レストランを見る",
    locEyebrow: "アクセス",
    locCta: "行き方",
    galleryEyebrow: "ギャラリー",
    galleryCta: "ギャラリー全体を見る",
    directEyebrow: "公式予約",
    directTitle: "ここでのご予約はいつもお得",
    directItems: [
      { t: "最低オンライン価格", d: "当ホテル公式サイトより低い料金を提示できる代理店はありません。" },
      { t: "柔軟な条件", d: "無料キャンセル可能、ホテルでのお支払いの料金プラン。" },
      { t: "直接のご対応", d: "仲介を介さず、ご滞在前後も直接ホテルのチームとやり取りいただけます。" },
      { t: "ウェルカムの心づかい", d: "空室状況に応じたレイトチェックアウトと公式予約のお客様限定の特典。" },
    ],
    testimonialsEyebrow: "お客様の声",
    testimonials: [
      { q: "工業地区での仕事に最適な立地。静かな客室と充実した朝食。毎月利用しています。", a: "Marc V.", r: "出張" },
      { q: "娘の初聖体をホールで祝いましたが、すべてが完璧でした。スタッフが細部まで対応してくれました。", a: "Laura & Jordi", r: "ご家族のお祝い" },
      { q: "駅まで徒歩2分、バルセロナまで30分。街とモンセラットを訪ねるための、静かで手入れの行き届いた拠点です。", a: "Claire D.", r: "小旅行" },
    ],
    contactEyebrow: "お話ししましょう",
    contactCta: "お問い合わせ",
    rfpCta: "お見積もりを依頼",
  },
  rooms: {
    eyebrow: "客室",
    surface: "広さ",
    occupancy: "定員",
    bed: "ベッド",
    bath: "バスルーム",
    features: "設備",
    guests: "名",
    book: "この客室を予約",
    all: "すべての客室",
    photosEyebrow: "ギャラリー",
    photosTitle: "客室とバスルーム",
    photosCount: "枚の写真",
    featureLabels: {
      wifi: "高速Wi-Fi",
      ac: "空調",
      tv: "テレビ",
      desk: "ワークデスク",
      minibar: "ミニバー",
      hairdryer: "ヘアドライヤー",
      crib: "ベビーベッド利用可",
      extra_bed: "エキストラベッド",
      accessible: "バリアフリー",
      nonsmoking: "禁煙",
    },
    servicesEyebrow: "サービス",
    family: {
      eyebrow: "ご家族での滞在に",
      title: "ファミリー向けオプション",
      beds: { t: "エキストラベッド（トリプル）", d: "エキストラベッドでお部屋をトリプルに。12歳未満のお子様は無料。" },
      crib: { t: "無料ベビーベッド", d: "お子様向けのベビーベッドを無料でご用意。" },
      note: "いずれも空き状況によります。ご予約時に事前にお申し付けください。",
    },
    servicesTitle: "必要なものは、すべて揃っています",
    services: [
      { t: "ビュッフェ朝食", d: "毎朝、地元産の食材、手作りのパン、ヘルシーな選択肢をご用意。" },
      { t: "専用駐車場", d: "別料金、空き状況により異なります。" },
      { t: "光ファイバーWi-Fi", d: "ホテル全館で対称型接続、追加料金なし。" },
      { t: "24時間フロント", d: "いつでも対応できるスタッフが常駐しています。" },
      { t: "フィットネスルーム", d: "ご滞在中もいつもの運動を続けられます。" },
      { t: "レストラン・バー", d: "ビジネスメニュー、地中海アラカルト、ゆったりとした一杯。" },
    ],
    notFound: "客室が見つかりません",
  },
  corporate: {
    eyebrow: "法人",
    title: "リョブレガート工業回廊における皆さまの拠点",
    pillars: [
      { t: "法人料金", d: "頻繁なご滞在と一括請求の企業向けに交渉した価格。" },
      { t: "会議室", d: "可動式の3つの空間、12名から180名まで。" },
      { t: "働くと休む", d: "全客室にデスク、Wi-Fi、早朝からの朝食。" },
      { t: "ビジネスケータリング", d: "ホテル内でのコーヒーブレイク、ワーキングランチ、チームディナー。" },
    ],
    salasEyebrow: "会議室",
    photosTitle: "会場とイベント",
    salasTitle: "皆さまのスケジュールに合わせる空間",
    salasCta: "すべての会議室と収容人数を見る",
    formEyebrow: "法人料金",
    formTitle: "法人料金をご依頼ください",
    formText: "チームが年間に必要な宿泊数をお知らせいただければ、24時間以内にご提案をご用意します。",
    capacityTitle: "レイアウト別収容人数",
    capacityLabels: { teatro: "シアター", escuela: "スクール", u: "コの字", imperial: "ロの字", coctel: "カクテル", banquete: "バンケット" },
    equipmentLabels: {
      wifi: "光ファイバーWi-Fi", proyector: "プロジェクター・スクリーン", flipchart: "フリップチャート", pizarra: "ホワイトボード",
      coffee_break: "コーヒーブレイク", agua: "ミネラルウォーター", escritura: "筆記用具", luz_natural: "自然光", panelable: "間仕切り可能",
    },
    area: "広さ",
    people: "名",
    upTo: "最大",
    requestRoom: "この会議室のお見積もりを依頼",
    salasIntro: "すべての会議室に光ファイバーWi-Fi、独立空調、AV設備、コーヒーブレイクサービスを完備。理想的なレイアウト選びをお手伝いします。",
    servicesTitle: "イベントのためのサービス",
    services: ["ウェルカムおよび午前のコーヒーブレイク", "ビジネスランチまたはワーキングビュッフェ", "登壇者と参加者の宿泊", "参加者用の駐車場", "イベント中の技術サポート", "事務局と筆記用具"],
    otherRooms: "その他の会議室",
    notFound: "会議室が見つかりません",
  },
  events: {
    eyebrow: "イベント・祝宴",
    title: "大切な日にふさわしい場所を",
    intro: "自然光あふれる220㎡のホール、自前のキッチン、そして誰も車で帰らなくてよい92室の客室で、結婚式、初聖体、記念日、グループでの集まりを。",
    types: [
      { key: "weddings", t: "ウエディング", d: "最大150名の宴会、ウェルカムカクテル、新郎新婦用のブライダルスイートを無料でご用意。", cta: "ウエディングを見る" },
      { key: "celebrations", t: "祝宴", d: "初聖体、洗礼、誕生日、記念日に、あらゆる年齢向けのオーダーメイドメニュー。", cta: "祝宴を見る" },
      { key: "groups", t: "グループ", d: "スポーツチーム、団体旅行、モンセラット巡礼者に特別条件をご用意。", cta: "グループ・旅行" },
    ],
    stepsEyebrow: "私たちの進め方",
    steps: [
      { t: "顔合わせ", d: "ホテルをご見学いただき、ご要望をうかがい、空間とメニューをご提案します。" },
      { t: "オーダーメイドのご提案", d: "48時間以内に確定見積もりを、追加費用なしで。ウエディングには事前の試食付き。" },
      { t: "当日", d: "専任コーディネーターが進行と業者を管理し、皆さまはただ楽しむだけ。" },
    ],
    formEyebrow: "イベントについてお聞かせください",
    formTitle: "計画を始めましょう",
    weddings: {
      title: "バルセロナから30分、マルトレイでのウエディング",
      intro: "宴会には自然光あふれる間仕切り可能なホール、カクテルにはテラス、新郎新婦とゲストには客室。自前の地中海キッチンと、最初のコーヒーから最後のダンスまで寄り添う専任コーディネーター。",
      includes: ["ウェルカムカクテル", "事前の試食付き宴会", "ブライダルスイート無料", "ゲスト向け特別料金", "オープンバーとDJ（オプション）"],
    },
    celebrations: {
      title: "初聖体、洗礼、記念日",
      intro: "大人も子供も楽しめるメニュー、子供向けエンターテインメントのスペース、そしてすべてを一つ屋根の下で整える安心感のあるご家族のお祝い。",
      includes: ["子供用・大人用メニュー", "エンターテインメント用スペース", "オーダーメイド装飾", "オリジナルケーキ", "フォトエリア", "ご親族用の客室"],
    },
    groups: {
      title: "グループ、チーム、団体旅行",
      intro: "早めの朝食、グループディナー、スムーズなチェックイン付きで、10名から180名のグループにご宿泊を。モンセラットとバルセロナへの理想的な出発点。",
      includes: ["10室からのグループ料金", "ご要望に応じた早めの朝食", "グループディナーとピクニック", "団体チェックイン"],
    },
    includesTitle: "ご提案に含まれるもの",
    back: "すべてのイベント",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "地中海の市場料理",
    hoursTitle: "営業時間",
    breakfast: "朝食",
    lunch: "昼食",
    dinner: "夕食",
    menuEyebrow: "ご提案",
    menus: [
      { t: "ビュッフェ朝食", d: "手作りのパン、フレッシュフルーツ、カタルーニャのシャルキュトリー、できたての卵料理、スペシャルティコーヒー。", p: "06:30 – 10:30" },
      { t: "ビジネスメニュー", d: "月曜から金曜のランチタイム。パン、ドリンク、コーヒー付きの市場の3皿。", p: "価格はお問い合わせください" },
      { t: "地中海アラカルト", d: "米料理、本日の魚、炭火焼きの肉、自家製デザートとペネデスのワイン。", p: "夕食と週末" },
      { t: "グループメニュー", d: "企業、祝宴、旅行グループ向けの固定プラン、10名様から。", p: "オーダーメイド" },
    ],
    reserveTitle: "テーブルを予約",
    reserveText: "お電話いただければ、その場でテーブルを確定します。",
    reserveCta: "レストランに電話する",
    reserveTap: "タップして発信",
    wineEyebrow: "ワインセラー",
    wineTitle: "ペネデスとカタルーニャ全土のワイン",
    wineText: "地域の小規模ワイナリーを優先した、短く誠実なリスト。季節の料理に寄り添うカバ、シャレロ、ガルナッチャ。",
  },
  location: {
    eyebrow: "アクセス・交通",
    title: "大切なすべての中心に",
    pois: [
      { name: "Renfe / FGC Martorell Enllaç 駅", dist: "100m", time: "徒歩2分", mode: "walk" },
      { name: "SEAT-CUPRA本社と工業団地", dist: "2.5km", time: "車で5分", mode: "car" },
      { name: "モンセラット修道院と自然公園", dist: "19km", time: "車で20分／登山鉄道", mode: "car" },
      { name: "バルセロナ市街地（エスパーニャ広場／カタルーニャ広場）", dist: "28km", time: "直通列車またはA-2で30分", mode: "train" },
      { name: "バルセロナ・エルプラット空港 (BCN)", dist: "32km", time: "高速道路で25分", mode: "plane" },
      { name: "カタルーニャ・バルセロナサーキット", dist: "45km", time: "AP-7経由で40分", mode: "car" },
    ],
    faqEyebrow: "よくある質問",
    faqTitle: "行き方と移動",
    mapCta: "Google マップで開く",
    addressTitle: "住所",
    transportTitle: "交通",
    transportItems: [
      { t: "電車で", d: "Renfe R4とFGC（Martorell Enllaç / Martorell Central）まで100m。バルセロナまで30分。" },
      { t: "車で", d: "A-2（出口585 Martorell）およびAP-7（出口25 Martorell）から直接アクセス。" },
      { t: "空港から", d: "高速道路で25分。タクシーまたはレンタカーをおすすめします。" },
    ],
  },
  gallery: {
    eyebrow: "ギャラリー",
    title: "写真で見るホテル",
    all: "すべて",
    cats: { habitaciones: "客室", restaurante: "レストラン", salas: "会議室", eventos: "イベント", fitness: "フィットネスルーム", comunes: "共用スペース" },
  },
  blog: {
    eyebrow: "ブログ・ガイド",
    title: "ゆったりと巡るマルトレイ、バルセロナ、モンセラット",
    read: "分で読めます",
    readMore: "記事を読む",
    back: "ブログに戻る",
    related: "関連記事",
    notFound: "記事が見つかりません",
  },
  contact: {
    eyebrow: "お問い合わせ",
    title: "ご滞在やイベントについてお話ししましょう",
    text: "営業時間内24時間以内にご返信します。客室のご予約は、最低価格保証の公式予約システムをご利用ください。",
    phone: "電話",
    email: "メール",
    address: "住所",
    hours: "24時間フロント",
    formEyebrow: "フォーム",
    formTitle: "どのようなご用件でしょうか？",
  },
  form: {
    type: "ご依頼の種類",
    types: { contacto: "一般的なお問い合わせ", empresa: "法人料金", salas: "会議室・会議のお見積もり", evento: "ウエディング・祝宴・グループ", restaurante: "レストラン予約" },
    name: "氏名",
    company: "会社・団体",
    email: "メール",
    phone: "電話",
    nights: "年間宿泊数（概算）",
    guests: "人数・ご利用人数",
    date: "ご希望日",
    attendees: "参加人数",
    eventType: "イベントの種類",
    eventTypes: ["ウエディング", "初聖体・洗礼", "記念日・誕生日", "会議・研修", "コンベンション", "旅行グループ", "その他"],
    setup: "ご希望のレイアウト",
    setups: ["シアター", "スクール", "コの字", "ロの字", "カクテル", "バンケット"],
    catering: "ケータリング",
    caterings: ["コーヒーブレイク", "ビジネスランチ", "夕食", "ケータリングなし"],
    lodging: "宿泊は必要ですか？",
    lodgings: ["はい", "いいえ", "確認中"],
    message: "コメント",
    messagePlaceholder: "ご要望をお聞かせください…",
    consent: "プライバシーポリシーと、本依頼への対応のための私のデータの取り扱いを読み、同意します。",
    submit: "依頼を送信",
    sending: "送信中…",
    success: "依頼を送信しました。24時間以内にご返信します。",
    error: "送信できませんでした。再度お試しいただくか、お電話ください。",
    required: "必須項目",
    invalidEmail: "メールが無効です",
    consentRequired: "プライバシーポリシーに同意する必要があります",
    select: "選択",
  },
  footer: {
    tagline: "マルトレイの4つ星ホテル。バルセロナから30分、休息、仕事、祝宴の場所。",
    explore: "探す",
    business: "法人",
    guides: "ガイド",
    legal: "法的事項",
    contact: "お問い合わせ",
    legalNotice: "法的通知",
    privacy: "プライバシー",
    cookies: "Cookie",
    cookieSettings: "Cookie 設定",
    rights: "無断複写・転載を禁じます。",
    registration: "観光登録",
    newsletter: "公式オファーを受け取る",
    newsletterText: "価値のある情報があるときだけお送りします。",
    subscribe: "登録する",
    subscribed: "ありがとうございます。随時お知らせします。",
    directBook: "公式予約 · 最低価格保証",
  },
  legal: {
    legal: { title: "法的通知", date: "2026年10月", sections: [
      ["識別情報", "情報社会サービスおよび電子商取引に関する2002年7月11日法律第34/2002号（LSSI-CE）の定めに従い、以下の情報をお知らせします：\n事業者：EYE STAR, S.L.\n商号：Hotel Ciutat Martorell\n税務番号（NIF）：B87171740\n本店所在地：Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)、スペイン\n施設所在地：Avda. Pau Claris, s/n, 08760 Martorell (Barcelona)、スペイン\n電話：+34 937 745 160\nメール：info@hotel-martorell.com\nウェブサイト：www.hotel-martorell.com\n登記情報：マドリード商業登記所、第32963巻、第138葉、登記簿 M-593334、第1登記。"],
      ["目的", "本法的通知は、ウェブサイト www.hotel-martorell.com へのアクセス、閲覧および利用、ならびにそのコンテンツおよび（該当する場合）本サイトを通じて提供されるサービスの利用から生じる責任を規定します。\n本ウェブサイトへのアクセスおよび閲覧は、利用者としての地位を付与し、本法的通知に定める条件の承諾を意味します。"],
      ["利用条件", "利用者は、現行法令、信義則、公序およびこの法的通知に従って本ウェブサイトを利用することを約束します。\n利用者は、違法な目的または本法的通知に反する目的での本ウェブサイトの利用、ならびに本ウェブサイト、そのコンテンツまたはそれを支えるシステムおよび機器を損傷、使用不能、過負荷もしくは劣化させ得るいかなる行為も控えなければなりません。"],
      ["知的財産権および産業財産権", "本ウェブサイトのすべてのコンテンツ（例示列挙であり限定ではないテキスト、写真、画像、図、ロゴ、アイコン、デザイン、構造、ソースコードその他本ウェブサイトを構成する要素を含む）は、EYE STAR, S.L. に帰属するか、またはその正当な権利者の該当する許諾を得て使用されています。\n当該コンテンツは、知的財産権および産業財産権に関する現行法令により保護されています。\nEYE STAR, S.L. の事前かつ明示的な許諾なく、本ウェブサイトのコンテンツの全部または一部を複製、配布、公衆送信、改変その他いかなる形態で利用することも、法律で認められる場合を除き禁止されます。"],
      ["責任", "EYE STAR, S.L. は、本ウェブサイトのコンテンツが正確かつ最新であるよう努めます。ただし、誤りや脱落がないことを保証せず、また、その支配の及ばない事情に起因する場合において、本ウェブサイトに含まれる情報の利用から生じ得る損害について責任を負いません。\nEYE STAR, S.L. は、本ウェブサイトの運用の可用性および継続性も保証せず、技術上・保守上の理由またはその支配の及ばない事情により中断が生じる場合があります。\n本ウェブサイトには第三者のウェブサイトへのリンクが含まれる場合があります。EYE STAR, S.L. は、当該外部ウェブサイトのコンテンツ、サービス、運用またはプライバシーポリシーについて一切の責任を負いません。"],
      ["個人データの保護", "本ウェブサイトを通じて収集され得る個人データの取扱いは、個人データ保護に関する現行法令に従って行われます。\nデータ管理者、処理の目的、法的根拠、受領者、保存期間、および利用者が行使できる権利に関する情報は、本ウェブサイトのプライバシーポリシーに掲載されています。"],
      ["Cookie", "本ウェブサイトは Cookie および類似の技術を使用する場合があります。\n使用する Cookie、その目的、関与し得る第三者、および利用者が設定を管理する方法に関する情報は、Cookie ポリシーに掲載されています。\n厳密に必要でない Cookie は、適用法令に従い、必要な場合には利用者の同意を事前に取得したうえで使用されます。"],
      ["商業的通信", "利用者が電子的手段による商業的通信の受信に同意している場合、これらは現行法令に従って行われます。\n利用者は、各通信において当該目的のために設けられた手段により、いつでも商業的通信の送信に反対することができます。"],
      ["変更", "EYE STAR, S.L. は、本ウェブサイトを通じて提供されるコンテンツおよびサービス、ならびに本法的通知を、いつでも事前の予告なく変更、更新または削除する権利を留保します。\n変更は、本ウェブサイトに公開された時点から適用されます。"],
      ["準拠法および管轄", "EYE STAR, S.L. と利用者との関係は、スペイン法に準拠します。\n本ウェブサイトへのアクセスまたは利用に関連して生じ得る紛争の解決については、適用法令に従って管轄権を有する裁判所が管轄します。\n利用者が消費者である場合には、適用される裁判管轄および消費者保護に関する強行規定が尊重されます。"],
    ]},
    privacy: { title: "プライバシーポリシー", date: "2025年7月18日", sections: [
      ["データ管理者", "会社名：EYE STAR SL\n税務番号（NIF）：B87171740\nドメイン：https://www.hotel-martorell.com/\n住所：Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nメール：administracion@hotel-martorell.com\n電話：+34 937 745 160"],
      ["データ保護", "個人データ保護に関する現行の適用法令に従い、お客様のデータは EYE STAR SL（税務番号 B87171740、所在地 Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)）が管理する処理システムに組み込まれることをお知らせします。以下に、実施している各処理に関する情報を記載します。"],
      ["宿泊のオンライン予約の管理", "目的：宿泊のオンライン予約の登録および管理。\n保存期間：3年（宿泊施設等における旅行者の登録簿および入館記録に関する2003年7月3日付命令 INT/1922/2003 に基づく）。\n法的根拠：本人の同意。\n基本データ：氏名、電話、税務番号（NIF）、メール、経済・保険関連データ。\n機微データ：未成年者に関するデータ。\n提供：必要な場合、適用法令が定める行政上および安全上の義務を履行するため、お客様のデータは税務当局、銀行・貯蓄銀行、治安部隊・機関および管轄当局に提供されます。提供を正当化する根拠は法律の遵守です。"],
      ["商業的活動（ウェブフォーム）", "目的：お問い合わせやご依頼に対応するため、ならびに広告および商業的勧誘のための、データの取得・登録・処理。\n保存期間：付与された同意が維持される間（法的義務がある場合を除く）。\n法的根拠：本人の同意。\n基本データ：氏名、メール。"],
      ["ウェブ利用者の管理", "目的：利用者データの取得・登録・処理。\n保存期間：付与された同意が維持される間（法的義務がある場合を除く）。\n法的根拠：本人の同意。\n基本データ：氏名、メール。"],
      ["Cookie の設置", "目的：Cookie の管理および設置。\n保存期間：付与された同意が維持される間。\n法的根拠：本人の同意。\n基本データ：メール、IP アドレス。"],
      ["ニュースレター", "目的：ニュースレター購読の管理および対応する配信の実施。\n保存期間：付与された同意が維持される間。\n法的根拠：本人の同意。\n基本データ：氏名、メール。"],
      ["ウェブフォームの管理", "目的：お問い合わせやご依頼への対応。\n保存期間：付与された同意が維持される間。\n法的根拠：本人の同意。\n基本データ：氏名、メール、IP アドレス。"],
      ["本人の権利", "お客様は、ご自身の個人データの処理に関するアクセス、訂正、制限、削除、ポータビリティおよび異議の権利、ならびに自動化された決定（プロファイリングを含む）の対象とならない権利を行使でき、付与した同意を撤回できます：\n• アクセス：データが処理されているか否かの確認、処理されている場合はその具体的なデータおよび処理に関する法的情報の取得。\n• 訂正：不正確または不完全なデータの訂正。\n• 制限：一定の場合における処理目的の制限。\n• 削除：GDPR に定める例外を除き、データの削除。\n• ポータビリティ：構造化され、一般的に使用され、機械判読可能な形式でデータを受け取り、別の管理者へ移転すること。\n• 異議：定められた場合において、データが処理されないこと、または処理の停止。\n• プロファイリングを含む自動化された決定の対象とならないこと。\n• 同意の撤回：いつでも無償で。"],
      ["権利の行使", "これらの権利を行使するには、Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)（EYE STAR SL 宛）に書面を提出するか、administracion@hotel-martorell.com までメールでご連絡ください。本人は確実に身元を証明する必要があり、身元に疑義がある場合には申請の補完を求められることがあります。申請は、正式に特定され授権された法定または任意の代理人が行うこともできます。行使しようとする権利を具体的に示し、通知のための住所を記載のうえ、必要な証明書類を添付してください。電話で情報が提供されることは一切ありません。"],
      ["監督機関への申立て", "ある事実が適用されるデータ保護法令への違反に当たるおそれがあるとお考えの場合、スペインデータ保護庁に申立てを行う権利があります。"],
      ["セキュリティ対策", "EYE STAR SL は、実施する処理のリスクレベルに応じて必要な技術的・組織的措置を講じ、データの完全性、機密性および可用性を保証することをお約束します。"],
    ]},
    cookies: { title: "Cookie ポリシー", sections: [
      ["Cookie とは", "Cookie は閲覧時にデバイスに保存される小さなファイルで、設定を記憶したりサイトの利用状況を測定したりできます。"],
      ["使用する Cookie", "動作に必要な技術的 Cookie（言語、管理セッション、Cookie 選択の記憶）と、ご同意いただいた場合のみ使用する Google Analytics 4 の分析 Cookie（_ga、_ga_*；最長 13 か月）。IP は匿名化され、サイトの利用状況の把握と改善に用います。"],
      ["第三者", "埋め込まれた Google マップと外部予約システムは、各自のポリシーに従って独自の Cookie をインストールする場合があります。"],
      ["管理方法", "ブラウザを設定して Cookie をブロックまたは削除できます。これによりサイトの一部機能に影響が出る場合があります。"],
      ["同意の管理", "初回アクセス時に、Cookie をカテゴリーごとに許可・拒否・設定できます。選択はフッターの「Cookie 設定」リンクからいつでも変更できます。分析 Cookie を拒否した場合、Google Analytics は Cookie を使用しないモード（Consent Mode）で動作し、匿名シグナルのみを受け取ります。"],
    ]},
    updated: "最終更新",
  },
  consent: {
    eyebrow: "Cookie",
    title: "プライバシーは、あなたの選択で",
    text: "当サイトでは必要なファーストパーティ Cookie を使用し、ご同意いただいた場合のみ、利用状況の把握と改善のために分析 Cookie（Google Analytics）を使用します。選択はフッターの「Cookie 設定」からいつでも変更できます。",
    more: "Cookie ポリシー",
    acceptAll: "すべて許可",
    reject: "拒否",
    configure: "設定",
    save: "選択を保存",
    close: "閉じる",
    always: "常に有効",
    necessary: { t: "必須", d: "サイトの動作に不可欠：言語、セキュリティ、Cookie 選択の記憶。" },
    analytics: { t: "分析", d: "IP を匿名化した Google Analytics。訪問数の測定とサイト改善のため。拒否した場合は Cookie を使わない匿名シグナルのみ送信されます。" },
    marketing: { t: "マーケティング", d: "キャンペーンの測定と Google 広告のパーソナライズのため。現在この種の Cookie は使用していません。" },
  },
  notFound: { title: "ページが見つかりません", text: "お探しのページは存在しないか、アドレスが変更されました。", cta: "ホームに戻る" },
  chat: {
    open: "ホテルアシスタント",
    close: "閉じる",
    title: "ホテルアシスタント",
    subtitle: "24時間すぐにお答えします",
    intro: "こんにちは。Hotel Ciutat Martorellのバーチャルアシスタントです。客室、朝食、アクセス、会議室、イベントについてお気軽にどうぞ。",
    placeholder: "ご質問を入力…",
    send: "送信",
    suggestions: ["朝食は何時からですか？", "バルセロナからの行き方は？", "駐車場はありますか？"],
    human: "スタッフと話しますか？",
    call: "電話",
    whatsapp: "WhatsApp",
    book: "予約",
    error: "現在お答えできません。お電話ください：",
    disclaimer: "自動アシスタントのため誤りがある場合があります。ご予約は「予約」ボタンから。",
  },
  admin: {
    googleLogin: "Googleでログイン",
    or: "または",
    aiTranslate: "AIでスペイン語から翻訳",
    login: "パネルへのアクセス",
    email: "メール",
    password: "パスワード",
    enter: "ログイン",
    logout: "ログアウト",
    panel: "コンテンツパネル",
    tabs: { nye: "大晦日", stats: "統計", ai: "AIアシスタント", leads: "依頼", content: "テキスト", rooms: "客室", meeting: "会議室", faqs: "FAQ", gallery: "ギャラリー", blog: "ブログ", survey: "サステナビリティ", settings: "ホテル情報" },
    save: "保存",
    saved: "保存しました",
    add: "追加",
    delete: "削除",
    status: { nuevo: "新規", en_proceso: "対応中", cerrado: "完了" },
    noLeads: "まだ依頼はありません。",
    resend: "通知を再送",
    resendOk: "通知を再送しました：",
    resendFail: "通知を送信できませんでした",
    notifySent: "メール通知を送信済み",
    notifyFailed: "メール通知の送信に失敗",
    notifyUnknown: "送信記録なし",
  },
  common: {
    seeMore: "もっと見る",
    bookNow: "今すぐ予約",
    call: "ホテルに電話",
    placeholderNote: "仮の写真",
  },
  pages: {
    rooms: {
      seoTitle: "マルトレイの客室 · 21m²のダブル＆ツイン",
      seoDesc: "光ファイバーWi-Fi、デスク、ビュッフェ朝食付きの客室。ダブル、ツイン。公式予約が最安値。",
      heroTitle: ["本当にくつろぐための", "客室"],
      heroText: "ビジネスにもレジャーにも、絶対的な安らぎのために設計された92室の客室。",
    },
    roomDetailSuffix: "客室",
    corporate: {
      seoTitle: "マルトレイのビジネスホテルと会議室",
      seoDesc: "法人料金、最大180名収容の会議室3室、SEAT-CUPRAとマルトレイ工業団地から5分の宿泊。24時間以内にお見積もり。",
      heroTitle: ["リョブレガート回廊における", "皆さまの拠点"],
    },
    meetingRooms: {
      seoTitle: "マルトレイの会議・イベント会場",
      seoDesc: "自然光あふれる35〜220㎡の3室で、12〜180名の会議・研修・コンベンションに対応。AV設備、光ファイバー、コーヒーブレイク完備。",
      heroTitle: ["3つの会議室、", "無限のレイアウト"],
    },
    events: {
      seoTitle: "マルトレイでの結婚式・祝宴・グループ",
      heroTitle: ["大切な日にふさわしい", "場所を"],
      stepsTitle: "3ステップ、心配ゼロ",
    },
    restaurant: {
      seoTitle: "マルトレイのレストラン · 地中海料理",
      heroTitle: ["地中海の", "市場料理"],
    },
    location: {
      seoTitle: "アクセス · バルセロナから30分のマルトレイのホテル",
      heroTitle: ["大切なすべての", "中心に"],
      distancesTitle: "距離と所要時間",
    },
    gallery: {
      seoDesc: "マルトレイの 4 つ星ホテル Hotel Ciutat Martorell の写真：ダブル・ツインの客室、バスルーム、会議室、バンケットホール、レストラン My Bar、共用スペース、周辺環境。",
      biosphereNote: "Hotel Ciutat Martorell は持続可能な観光の Biosphere 認証を取得しています。サステナビリティに関する当ホテルのすべての取り組みと約束は、公式プロフィールで直接ご覧いただけます。",
    },
    blog: { seoDesc: "マルトレイ、バルセロナ、モンセラットの実用ガイド：電車・車でのアクセス、見どころ、食事スポット、ビジネス旅行者とファミリー向けのヒント。" },
    faq: { eyebrow: "よくあるご質問", home: "よくいただくご質問", rooms: "客室について", corporate: "会議・ビジネス利用について", events: "ウェディング・お祝い・団体について", restaurant: "レストランについて" },
    biosphere: { seoTitle: "サステナビリティ · Biosphere 認証" },
    contact: { hoursValue: "チェックイン 15:00 · チェックアウト 12:00" },
    seal: { sustainableTourism: "持続可能な観光", certifiedBy: "認証", viewCert: "認証を見る" },
    bookingCta: {
      eyebrow: "公式予約",
      rooms: { title: "最安値保証で予約", text: "公式サイトから直接予約すれば、仲介も手数料もなく最安値。" },
      location: { title: "バルセロナとモンセラットから30分", text: "RenfeとFGCの駅に隣接したホテルに滞在、空港まで30分。公式サイトなら最安値保証で予約。" },
    },
    blogPost: {
      sidebarTitle: "駅から100mで安眠",
      cta: {
        eyebrow: "公式予約",
        secondary: "見積もりを依頼",
        transport: { title: "駅から100mで安眠", text: "RenfeとFGCの駅に隣接したホテルに滞在し、30分でバルセロナへ。公式サイトなら最安値保証。" },
        guides: { title: "マルトレイ観光の拠点に", text: "バルセロナ、モンセラット、空港すべて30分。公式予約で旅の計画を始めましょう。" },
        business: { title: "御社のための宿泊と会議室", text: "工業地区から5分、会議室と法人料金をご用意。オーダーメイドのお見積もりをお申し付けください。" },
        default: { title: "マルトレイでのご滞在を予約", text: "バルセロナから30分の4つ星ホテル。公式予約なら最安値保証。" },
      },
    },
    homeHeadings: {
      presentation: ["マルトレイの4つ星ホテル。", "休息、仕事、お祝いを", "バルセロナから30分。"],
      gastronomy: ["地中海の市場料理を、", "ゆったりと"],
      extras: ["イベント、会議、", "それとも長期滞在？"],
      heroRooms: "客室",
    },
  },
};

export default ja;
